import * as Yup from 'yup';
import { Address } from 'utils/schemas';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    fromOrg: Yup.boolean().nullable().required('Please select an option'),
    address: Address.nullable().when('fromOrg', {
      is: false,
      then: (fieldSchema) => fieldSchema.required(),
    }),
  }),
});
